<template>
  <el-dialog title="Добавление домофона клиенту" :visible="visible" v-on="$listeners" @close="onClose">
    <el-form id="formServer" label-position="right" label-width="150px">
      <el-form-item label="Домофон">
        <select-intercom-available
          :client-id="clientId"
          :visible="visible"
          :intercom-id="client_intercom.id_intercom"
          @change="(intercom) => (client_intercom.id_intercom = intercom.id_intercom)"
          @clear="() => (client_intercom.id_intercom = null)"
        />
      </el-form-item>
      <el-form-item label="Квартира" prop="apartment">
        <el-input id="apartment" size="small" v-model="client_intercom.apartment"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="onClose">Отменить</el-button>
      <el-button id="submitIntercom" :loading="requestLoading" type="primary" @click="onSave">
        Добавить
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";
import SelectIntercomAvailable from "@/core/components/features/SelectIntercomAvailable";
export default {
  name: "ClientIntercomsDialog",
  components: { SelectIntercomAvailable },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    clientId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      requestLoading: false,
      client_intercom: {
        id_intercom: null,
        apartment: "",
      },
    };
  },
  methods: {
    ...mapActions("client", {
      addIntercom: "ADD_CLIENT_INTERCOM",
    }),
    onSave() {
      this.addIntercom({clientId: this.clientId, payload: { id_intercom: this.client_intercom.id_intercom, apartment: this.client_intercom.apartment }}).then(() => {
        this.$message.success("Домофон добавлен");
        this.$emit("update:visible", false);
        this.$emit("added", false);
        this.client_intercom.id_intercom = null;
        this.client_intercom.apartment = null;
      });
    },
    onClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>
